export type { ColorPreset } from './appearanceColorPresetTypes'
export { DARK_DEFAULT_PRESET, LIGHT_DEFAULT_PRESET } from './appearanceColorPresetTypes'
import { DARK_COLOR_PRESETS } from './appearanceColorPresetsDark'
import { LIGHT_COLOR_PRESETS } from './appearanceColorPresetsLight'
import type { ColorPreset } from './appearanceColorPresetTypes'

export const COLOR_PRESETS: ColorPreset[] = [
  ...DARK_COLOR_PRESETS,
  ...LIGHT_COLOR_PRESETS,
]
